import {useAlert} from 'react-alert';
import {alertTypes, IAlert} from '../store/types';
import {handleError, handleSuccess} from '../store/app.slice';
import {useAppDispatch} from './app';

export const useAppAlert = () => {
    const alert = useAlert();
    const dispatch = useAppDispatch();

    function initAlert({text, type}:IAlert) {
        switch (type) {
            case alertTypes.SUCCESS:
                return alert.success(text, {
                    onClose: () => {
                        dispatch(handleSuccess(null));
                    }
                });
            case alertTypes.ERROR:
                return alert.error(text, {
                    onClose: () => {
                        dispatch(handleError(null));
                    }
                });
            default:
                return alert.info(text, {
                    onClose: () => {
                        dispatch(handleError(null));
                    }
                });
        }
    }

    return {initAlert};
};
